exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-764fa8ca] .imosPlayer_title_btnDiv{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important}[data-v-764fa8ca] .imosPlayer{-webkit-box-sizing:border-box!important;box-sizing:border-box!important}", ""]);

// exports
